import React from 'react';
import {
  Box, Grid, TextField, Typography, Divider, Paper,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow
} from '@mui/material';
import FormSection from './FormSection';

const TotalsSection = ({ formData, handleInputChange }) => {
  return (
    <FormSection title="Totaux">
      <Grid container spacing={3}>
        <Grid item xs={12} sm={4}>
          <TextField
            label="Total HT"
            name="total_ht"
            value={formData?.total_ht?.toFixed(2) || '0.00'}
            onChange={handleInputChange}
            fullWidth
            required
            margin="normal"
            InputProps={{ endAdornment: '€' }}
            type="number"
            inputProps={{ step: 0.01 }}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            label="Total TVA"
            name="total_tax"
            value={formData?.total_tax?.toFixed(2) || '0.00'}
            onChange={handleInputChange}
            fullWidth
            required
            margin="normal"
            InputProps={{ endAdornment: '€' }}
            type="number"
            inputProps={{ step: 0.01 }}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            label="Total TTC"
            name="total_ttc"
            value={formData?.total_ttc?.toFixed(2) || '0.00'}
            onChange={handleInputChange}
            fullWidth
            required
            margin="normal"
            InputProps={{ endAdornment: '€' }}
            type="number"
            inputProps={{ step: 0.01 }}
          />
        </Grid>
      </Grid>
      
      {formData?.taxes_detail && formData.taxes_detail.length > 0 && (
        <Box sx={{ mt: 3 }}>
          <Typography variant="subtitle1" gutterBottom>
            Détail des taxes
          </Typography>
          <TableContainer component={Paper} variant="outlined">
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Taux (%)</TableCell>
                  <TableCell align="right">Montant</TableCell>
                  <TableCell>Code</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {formData.taxes_detail.map((tax, index) => (
                  <TableRow key={index}>
                    <TableCell>{tax.rate}</TableCell>
                    <TableCell align="right">{tax.amount.toFixed(2)} €</TableCell>
                    <TableCell>{tax.code || '-'}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      )}

      <Divider sx={{ my: 3 }} />

      <Grid container spacing={3}>
        <Grid item xs={12} sm={12}>
          <TextField
            label="Informations de paiement"
            name="payment_info"
            value={formData?.payment_info || ''}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
            placeholder="IBAN, RIB, etc."
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Notes"
            name="notes"
            value={formData?.notes || ''}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
            multiline
            rows={3}
          />
        </Grid>
      </Grid>
      
      {formData?.processing_metadata && (
        <Box sx={{ mt: 3 }}>
          <Typography variant="subtitle1" gutterBottom>
            Métadonnées d'extraction
          </Typography>
          <Paper variant="outlined" sx={{ p: 2 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Typography variant="body2" color="text.secondary">
                  Version du modèle: {formData.processing_metadata.product_version || 'N/A'}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body2" color="text.secondary">
                  Rotation appliquée: {formData.processing_metadata.rotation_applied || 'Aucune'}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body2" color="text.secondary">
                  Temps de traitement: {formData.processing_metadata.processing_time || 'N/A'}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body2" color="text.secondary">
                  Score de confiance: {formData.confidence_score ? (formData.confidence_score * 100).toFixed(1) + '%' : 'N/A'}
                </Typography>
              </Grid>
            </Grid>
          </Paper>
        </Box>
      )}
    </FormSection>
  );
};

export default TotalsSection;